import { APP_ROUTES } from 'shared/constants/navigation';

const RequireEventUserRole = (context) => {
    if (!context.store.isAuthedEventUser) {
        return APP_ROUTES.eventUser.eventUserSignUp;
    }
    return 'next';
};

export default RequireEventUserRole;
